<div class="status-legend flex-row">
    <div class="grow-4"></div>
    <div
        class="status flex-row"
        *ngFor="let legend of legendLabels; let i = index"
    >
        <div
            class="status-square"
            [ngStyle]="{
                'background-color': legend?.statusColor + '80',
                border: '1px solid ' + legend?.statusColor
            }"
        ></div>
        <div class="status-name">{{ legend?.parentStatusName }}</div>
    </div>
    <div class="grow-4"></div>
</div>
<div #chartTarget *ngIf="requestState"></div>
